<template>
  <div>
    <vue-form-generator ref="actionForm" :schema="schema" :model="model" :options="formOptions"></vue-form-generator>
    <b-button variant="success" @click="save()" v-if="branch && Object.keys(this.branch).length !== 0"
      >Сохранить</b-button
    >
    <b-button variant="success" @click="create()" v-else>Добавить</b-button>
  </div>
</template>

<script>
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";
export default {
  name: "newBranch",
  props: {
    devNames: Object,
    parent: Object,
    outflow: Number,
    logic: Object,
    object: Object,
    branch: Object,
  },
  mounted() {
    if (this.branch && Object.keys(this.branch).length !== 0) {
      this.$set(this, "model", JSON.parse(JSON.stringify(this.branch)));
    } else {
      Object.assign(this.$data, this.$options.data.call(this));
    }

    this.schema.groups[0].fields[0].values.push({ id: 0, name: "Нет" });
    if (this.logic[this.outflow].find((el) => el == 1))
      this.schema.groups[0].fields[0].values.push({ id: 1, name: "Пожар пролива" });
    if (this.logic[this.outflow].find((el) => el == 2))
      this.schema.groups[0].fields[0].values.push({ id: 2, name: "Волна давления при сгорании паровоздушного облака" });
    if (this.logic[this.outflow].find((el) => el == 3))
      this.schema.groups[0].fields[0].values.push({ id: 3, name: "Тепловое излучение пожара-вспышки" });
    if (this.logic[this.outflow].find((el) => el == 4))
      this.schema.groups[0].fields[0].values.push({ id: 4, name: "Образование огненного шара" });
    if (this.logic[this.outflow].find((el) => el == 5))
      this.schema.groups[0].fields[0].values.push({ id: 5, name: "Струйное горение горизонтального факела" });
    if (this.logic[this.outflow].find((el) => el == 6))
      this.schema.groups[0].fields[0].values.push({ id: 6, name: "Струйное горение вертикального факела" });
    if (this.logic[this.outflow].find((el) => el == 7))
      this.schema.groups[0].fields[0].values.push({ id: 7, name: "Взрыв установки с перегретой жидкостью" });
  },

  data() {
    return {
      factors: [],
      model: {
        id: null,
        factor: 0,
        C: "Название",
        P: 0,
        Pt: false,
        Pc: false,
        auto_calc: "manual",
        validator: {},
      },
      schema: {
        groups: [
          {
            fields: [
              {
                type: "select",
                inputType: "select",
                label: "Поражающий фактор",
                model: "factor",
                required: true,
                selectOptions: {
                  hideNoneSelectedText: true,
                },
                values: [],
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "text",
                label: "Название",
                model: "C",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
                visible: function (model) {
                  if (model.factor > 0) {
                    return false;
                  } else {
                    return true;
                  }
                },
              },
              {
                type: "select",
                inputType: "select",
                label: "Условная вероятность",
                model: "auto_calc",
                required: true,
                selectOptions: {
                  hideNoneSelectedText: true,
                },
                values: [
                  { id: "manual", name: "Задать вручную" },
                  { id: "calm", name: "Вероятность штиля" },
                  { id: "r_calm", name: "1 - Вероятность штиля" },
                  { id: "instant_ignition", name: "Условная вероятность мгновенного воспламенения (Таблица П2.1)" },
                  {
                    id: "r_instant_ignition",
                    name: "1 - Условная вероятность мгновенного воспламенения (Таблица П2.1)",
                  },
                  { id: "subsequent_ignition", name: "Условная вероятность последующего воспламенения (Таблица П2.1)" },
                  {
                    id: "r_subsequent_ignition",
                    name: "1 - Условная вероятность последующего воспламенения (Таблица П2.1)",
                  },
                  {
                    id: "overpressure_combustion",
                    name: "Условная вероятность сгорания с образованием избыточного давления (Таблица П2.1)",
                  },
                  {
                    id: "r_overpressure_combustion",
                    name: "1 - Условная вероятность сгорания с образованием избыточного давления (Таблица П2.1)",
                  },
                ],
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Условная вероятность",
                model: "P",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
                visible: function (model) {
                  //visible if business is selected1 5 6 7 8 9
                  if (!model.auto_calc || model.auto_calc == "manual") {
                    return true;
                  } else {
                    return false;
                  }
                },
              },
              {
                type: "switch",
                label: "Учитывать систему пожаротушения",
                model: "Pt",
                textOn: "Да",
                textOff: "Нет",
                valueOn: "1",
                valueOff: "0",
                visible: function (model) {
                  //visible if business is selected1 5 6 7 8 9
                  if (model.factor > 0) {
                    return true;
                  } else {
                    return false;
                  }
                },
              },
              {
                type: "switch",
                label: "Учитывать сигнализацю",
                model: "Pc",
                textOn: "Да",
                textOff: "Нет",
                valueOn: "1",
                valueOff: "0",
                visible: function (model) {
                  //visible if business is selected1 5 6 7 8 9
                  if (model.factor > 0) {
                    return true;
                  } else {
                    return false;
                  }
                },
              },
            ],
          },
        ],
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
        validateAsync: true,
      },
    };
  },
  components: {
    "vue-form-generator": VueFormGenerator.component,
  },
  methods: {
    create() {
      this.$http
        .post("risk/tree/action-add?parent_id=" + this.parent.id + "&obj_type=" + this.object.obj_type, this.model)
        .then((response) => {
          if (!this.parent.trees) {
            this.$set(this.parent, "trees", []);
          }
          this.$nextTick(() => {
            this.parent.trees.push(response.data);
          });
          this.$set(this.model, "validator", {});
          this.$emit("clearCalculations");
          this.$emit("hideActionWindow");
        })
        .catch((e) => {
          this.$set(this.model, "validator", {});
          this.$set(this.model, "validator", e.response.data);
          this.$refs.actionForm.validate();
        });
    },
    save() {
      this.$http
        .post("risk/tree/action-update?id=" + this.branch.id + "&obj_type=" + this.object.obj_type, this.model)
        .then((response) => {
          this.$emit("updateBranch", response.data);
          this.$set(this.model, "validator", {});
          this.$emit("clearCalculations");
          this.$emit("hideActionWindow");
        })
        .catch((e) => {
          this.$set(this.model, "validator", {});
          this.$set(this.model, "validator", e.response.data);
          this.$refs.actionForm.validate();
        });
    },
  },
};
</script>

<style scoped>
*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

body {
  min-width: 1200px;
  margin: 0;
  padding: 50px;
  color: #eee9dc;
  font: 16px Verdana, sans-serif;
  background: #2e6ba7;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

#wrapper {
  position: relative;
}

.branch {
  position: relative;
  margin-left: 250px;
}
.branch:before {
  content: "";
  width: 20px;
  border-top: 2px solid #eee9dc;
  position: absolute;
  left: -70px;
  top: 50%;
  margin-top: 1px;
}

.entry {
  position: relative;
  min-height: 150px;
}
.entry:before {
  content: "";
  height: 100%;
  border-left: 2px solid #eee9dc;
  position: absolute;
  left: -50px;
}
.entry:after {
  content: "";
  width: 50px;
  border-top: 2px solid #eee9dc;
  position: absolute;
  left: -50px;
  top: 50%;
  margin-top: 1px;
}
.entry:first-child:before {
  width: 10px;
  height: 50%;
  top: 50%;
  margin-top: 2px;
  border-radius: 10px 0 0 0;
}
.entry:first-child:after {
  height: 10px;
  border-radius: 10px 0 0 0;
}
.entry:last-child:before {
  width: 10px;
  height: 50%;
  border-radius: 0 0 0 10px;
}
.entry:last-child:after {
  height: 10px;
  border-top: none;
  border-bottom: 2px solid #eee9dc;
  border-radius: 0 0 0 10px;
  margin-top: -9px;
}
.entry.sole:before {
  display: none;
}
.entry.sole:after {
  width: 50px;
  height: 0;
  margin-top: 1px;
  border-radius: 0;
}

.label {
  display: block;
  width: 180px;
  padding: 5px 10px;
  line-height: 20px;
  text-align: center;
  border: 2px solid #eee9dc;
  border-radius: 5px;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -15px;
}
</style>
